import React from "react";
import { Provider, Routes } from "./moonwave/react";
import { AppProvider } from "@shopify/polaris";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import client from "./apollo/client";
import ErrorBoundary from "./components/ErrorBoundary";
import App from "./pages/App";
// import Protected from "./pages/Protected";
// import Chrome from "./pages/Chrome";
// import Login from "./pages/Login";
// import TwoFactorAuthPhone from "./pages/TwoFactorAuthPhone";
// import TwoFactorAuthSubmitCode from "./pages/TwoFactorAuthSubmitCode";
// import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import PasswordReset from "./pages/PasswordReset";
// import AddConnection from "./pages/AddConnection";
// import RemoveConnection from "./pages/RemoveConnection";
// import Settings from "./pages/Settings";
import StoreToken from "./pages/StoreToken";
import NotFound from "./pages/NotFound";
// import MyInbox from "./pages/MyInbox";
// import Directory from "./pages/Directory";
// import Patient from "./pages/Patient";
// import Invite from "./pages/Invite";
// import InviteDetails from "./pages/InviteDetails";
// import PendingInvites from "./pages/PendingInvites";
// import Connection from "./pages/Connection";
import Consult from "./pages/Consult";
import Forms from "./pages/Forms";

const components = {
  App,
  ForgotPassword,
  PasswordReset,
  StoreToken,
  NotFound,
  Consult,
  Forms
};

const Root = ({ atom, router }) => (
  <ErrorBoundary>
    <ApolloProvider client={client}>
      <Provider atom={atom}>
        <AppProvider>
          <BrowserRouter>
            <Routes router={router} components={components} />
          </BrowserRouter>
        </AppProvider>
      </Provider>
    </ApolloProvider>
  </ErrorBoundary>
);

export default Root;
